import ApiMiIndicador from '@/api/apiMiIndicador'

export const indicadorService = {
  getAll,
  getByIndicador,
}

async function getAll() {
  return await ApiMiIndicador.get('api/')
}

async function getByIndicador(indicador) {
  return await ApiMiIndicador.get('api/' + indicador)
}
